import { render, staticRenderFns } from "./PermisosRefresh.vue?vue&type=template&id=5508e23a&"
import script from "./PermisosRefresh.vue?vue&type=script&lang=js&"
export * from "./PermisosRefresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports